<div class="st-confirmation-header">
    <mat-icon class="material-icons-outlined">help_outline</mat-icon>
    <div class="st-confirmation-header-title">{{ title }}</div>
</div>
<div class="st-confirmation-body">{{ message }}</div>
<div class="st-confirmation-footer">
    <button
        mat-button
        class="st-confirmation-button-cancel"
        (click)="onCancelClick()">
        {{ cancelLabel }}
    </button>
    <button
        mat-button
        class="st-confirmation-button-no"
        (click)="onNoClick()">
        {{ noLabel }}
    </button>
    <button
        mat-button
        class="st-confirmation-button-yes"
        cdkInitialFocus
        (click)="onYesClick()">
        {{ yesLabel }}
    </button>
</div>
